<div class="btn-group" container="body" ngbDropdown role="group" aria-label="Button group with nested dropdown">
  <button class="btn btn-link float-right dropdown-no-arrow" style="z-index: 102" ngbDropdownToggle title="Toggle Actions Dropdown"
  (click)="preventDefault($event)">
    <span class="fa-solid fa-ellipsis-vertical"></span>
  </button>
  <div class="dropdown-menu" ngbDropdownMenu>
    <button (click)="openMask()"
            [disabled]="(!superOrTechAdminRole) || !isEditable"
            ngbDropdownItem
            title="{{'Change how aliases should be handled by default from now on.'|translate}}"
            type="button">
      <span>
      <span class="fa-solid fa-pen"></span>
      <span translate>Edit</span>
      </span>
    </button>

    <button (click)="onImportConnectorConfig(); uploader.click()"
            [disabled]="(!superOrTechAdminRole) || !isEditable"
            ngbDropdownItem
            title="{{'Import alias configuration'|translate}}"
            type="button">
      <span>
        <span class="fa-solid fa-file-import"></span>
        <span translate>Import</span>
      </span>
      <input #uploader
             (change)="onFileSelected($event)"
             (click)="onClickFileInput(uploader)"
             [hidden]="true"
             accept="{{'.'+jsonType}}"
             class="hidden-file-upload"
             id="{{'logo_'+name}}"
             type="file"/>
    </button>

    <button (click)="onExportConnectorConfig()"
            [disabled]="(!superOrTechAdminRole) || !isEditable"
            ngbDropdownItem
            title="{{'Export alias configuration'|translate}}"
            type="button">
      <span>
        <span class="fa-solid fa-file-export"></span>
        <span translate>Export</span>
      </span>
    </button>

    <button (click)="onDeleteAlias()" #deleteButton
            [disabled]="(!superOrTechAdminRole) || !isEditable"
            [ngClass]="{'text-danger': !deleteButton.classList.contains('disabled')}"
            ngbDropdownItem
            title="{{'Delete alias'|translate}}"
            type="button">
      <span>
        <span class="fa-solid fa-trash"></span>
        <span translate>Delete</span>
      </span>
    </button>

  </div>
</div>
